import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ShippingCountryBaseFragment = { id: string, pk: number, shippingTime: string };

export const ShippingCountryBaseFragmentDoc = gql`
    fragment ShippingCountryBaseFragment on ShippingMethodCountryType {
  id
  pk
  shippingTime
}
    `;